import React from "react";

import { Props } from "./types";
import asset from "./asset.gif";
import styles from "./styles.scss";

function DummyPage(_: Props) {
  return (
    <div className={styles.dummyPage}>
      <img src={asset} alt="Rémi was there" className={styles.main} />
    </div>
  );
}

export { DummyPage };
